export const isValidEmailAddress = value => {
  return String(value)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const isValidCompanyName = value => {
  return String(value)
    .toLowerCase()
    .match(/^[a-zA-Z\d ]+$/);
};

export const isValidMerchantId = value => {
  return String(value).match(/^[a-zA-Z0-9]+$/);
};

export const FIELDS_INFO = {
  merchantId: { range: 30, required: false },
  firstName: { range: 35, required: true },
  lastName: { range: 35, required: true },
  companyName: { range: 35, required: true },
  emailAddress: { range: 150, required: true },
  country: { required: true },
  captchaInput: { range: 6, required: true }
};

export const requiredFields = Object.keys(FIELDS_INFO).filter(
  field => FIELDS_INFO[field].required
);

export const validateInputField = (field, value) => {
  const errors = {};
  const trimmedValue = value.trim();

  if (!requiredFields.includes(field) && !trimmedValue) {
    return errors;
  }

  if (!trimmedValue) {
    errors[field] = {
      id: 'developer.account.creation.form.validation.required',
      defaultMessage: 'Can not be empty'
    };
  } else if (FIELDS_INFO[field]?.range && value.length > FIELDS_INFO[field].range) {
    errors[field] = {
      id: 'developer.account.creation.form.validation.length',
      defaultMessage: 'The value is too long'
    };
  } else if (field === 'merchantId' && !isValidMerchantId(value)) {
    errors[field] = {
      id: 'developer.account.creation.form.validation.merchantId',
      defaultMessage: 'Please enter a valid Merchant ID'
    };
  } else if ((field === 'companyName') && !isValidCompanyName(value)) {
    errors[field] = {
      id: `developer.account.creation.form.validation.${field}`,
      defaultMessage: 'Please enter a valid name'
    };
  } else if (field === 'emailAddress' && !isValidEmailAddress(value)) {
    errors[field] = {
      id: 'developer.account.creation.form.validation.email',
      defaultMessage: 'Please enter a valid email address'
    };
  }

  return errors;
};

const normalizeValue = value => String(value || '').toLowerCase();

export const getTermsAndConditionsUrl = (termsAndConditions, country, locale) => {
  if (!Array.isArray(termsAndConditions) || !termsAndConditions.length) {
    return undefined;
  }

  const normalizedCountry = normalizeValue(country);
  const normalizedLocale = normalizeValue(locale).split('-')[0];
  const countryMatch =
    termsAndConditions.find(item => normalizeValue(item?.country) === normalizedCountry) ||
    termsAndConditions.find(item => normalizeValue(item?.country) === '*');
  const languages =
    (Array.isArray(countryMatch?.languages) ? countryMatch.languages : []).filter(item => {
      return Boolean(item?.url);
    });

  if (!languages.length) {
    return undefined;
  }

  return (
    languages.find(item => normalizeValue(item?.language) === normalizedLocale)?.url ||
    languages.find(item => normalizeValue(item?.language) === '*')?.url ||
    languages.find(item => normalizeValue(item?.language) === 'en')?.url ||
    languages[0].url
  );
};

//  constants
export const URLs = {
  accountCreationUrl: '/create-account',
  captchaUrl: '/captcha',
  instanceSettingsUrl: '/instances/{instanceId}/settings',
  ispSettingsUrl: '/isps/{isp}/settings'
};

export const initalFormState = {
  merchantId: '',
  firstName: '',
  lastName: '',
  companyName: '',
  emailAddress: '',
  country: '',
  captchaInput: ''
};
export const initalFormError = {
  merchantId: '',
  firstName: '',
  lastName: '',
  companyName: '',
  emailAddress: '',
  captchaInput: ''
};
export const initalIcon = {
  merchantId: '',
  firstName: '',
  lastName: '',
  companyName: '',
  emailAddress: '',
  captchaInput: ''
};
